// -----------------------------------------------------------------------------
// PLUGINS/ELM
// -----------------------------------------------------------------------------
import { Plugin } from "prosemirror-state";
// -----------------------------------------------------------------------------
export function elmPlugin(id, app) {
    return new Plugin({
        state: {
            init() {
                return {};
            },
            apply(tr, value, oldState, newState) {
                if (app) {
                    app.ports.syncEditor.send({ id: id, doc: JSON.stringify(newState.toJSON().doc) });
                }
                return value;
            }
        }
    });
}
